import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { isDefined } from 'common/utils';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { StyledCheckbox } from '../OfferDetailsFormFields.styles';
import { AvailabilityDetails, FormValues } from '../types';

export const DeliveryMethods = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();

  const { values } = useFormState<FormValues>();

  const enabledDeliveryMethodsNames = [
    !!offer?.delivery_methods?.includes('eatin') ? { id: 'delivery-types.eatin' } : undefined,
    !!offer?.delivery_methods?.includes('takeaway') ? { id: 'delivery-types.takeaway' } : undefined,
    !!offer?.delivery_methods?.includes('homedelivery') ? { id: 'delivery-types.homedelivery' } : undefined,
  ].filter(isDefined);

  const previewComponent = (
    <>
      {enabledDeliveryMethodsNames?.length > 0
        ? enabledDeliveryMethodsNames.map(({ id }) => intl.formatMessage({ id })).join(', ')
        : '-'}
    </>
  );

  const editComponent = (
    <>
      <Field<AvailabilityDetails['enableEatin']> name="enableEatin">
        {({ input }) => (
          <StyledCheckbox checked={input.value} onChange={() => input.onChange(!input.value)}>
            <FormattedMessage id="delivery-types.eatin" />
          </StyledCheckbox>
        )}
      </Field>

      <Field<AvailabilityDetails['enableTakeaway']> name="enableTakeaway">
        {({ input }) => (
          <StyledCheckbox checked={input.value} onChange={() => input.onChange(!input.value)}>
            <FormattedMessage id="delivery-types.takeaway" />
          </StyledCheckbox>
        )}
      </Field>

      <Field<AvailabilityDetails['enableDelivery']> name="enableDelivery">
        {({ input }) => (
          <StyledCheckbox checked={input.value} onChange={() => input.onChange(!input.value)}>
            <FormattedMessage id="delivery-types.homedelivery" />
          </StyledCheckbox>
        )}
      </Field>
    </>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.deliveryMethods' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.enableEatin && !values.enableTakeaway && !values.enableDelivery}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
